const getItem = (key: string, defaultValue: any) => {
    try {
        const item = window.sessionStorage.getItem(key);

        return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
        console.error(error);
        return defaultValue;
    }
};

const setItem = (key: string, value: any) => {
    try {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(error);
    }
};

const clear = () => {
    try {
        window.sessionStorage.clear();
    } catch (error) {
        console.error(error);
    }
};

const removeItem = (key: string) => {
    try {
        window.sessionStorage.removeItem(key);
    } catch (error) {
        console.error(error);
    }
};

const SessionStorage = {
    getItem,
    setItem,
    clear,
    removeItem
};

export default SessionStorage;
